import Input from "./input";

const MainInputs = ({ mainData, changeHandler }) => {
  return (
    <>
      {Object.entries(mainData).map(([key, innerObj]) => {
        return (
          <Input
            key={key}
            id={key}
            label={key}
            control={innerObj.type}
            onChange={changeHandler}
            // onBlur={this.inputBlurHandler.bind(this, "ServiceName")}
            // valid={this.state.postForm["ServiceName"].valid}
            // touched={this.state.postForm["ServiceName"].touched}
            value={innerObj.value}
          />
        );
      })}
    </>
  );
};

export default MainInputs;
